export class LoggerLevel {
  public static readonly Error: string = 'Error';
  public static readonly Info: string = 'Info';
  public static readonly Event: string = 'Event';
  public static readonly Debug: string = 'Debug';
}
